export default __webpack_public_path__ + "media/images/home/en/preview-3-ff102ab8ee3800c95736b3bf64a86eaf.jpg";